/**
 * VierBeinerGlück · Upsell-Popup Mapping
 * ─────────────────────────────────────────────────────────────
 * Pro Basis-Produkt-Handle:
 *   - duo:     Stufe-1-Popup (Set aus 2 Produkten)
 *   - trio:    Stufe-2-Popup (Set aus 3 Produkten, optional)
 *   - seasonal: true → enthält stattdessen summer + winter Varianten
 *
 * Preis-Logik:
 *   - original_price = Summe der Einzelpreise + 5,95 € Versand
 *   - saving_amount  = original_price - set_price
 *   - saving_percent = gerundet auf ganze Zahl
 *
 * Bilder werden nicht hier gepflegt – sie werden im Liquid-Snippet
 * dynamisch über die Handles aus dem Theme geladen.
 *
 * Stand: Mai 2026
 * ─────────────────────────────────────────────────────────────
 */

window.VBG_UPSELL_MAP = {

  // ─────────────────────────────────────────────────────────
  // 1. DENTAL SPRAY
  // ─────────────────────────────────────────────────────────
  "hunde-zahnstein-dental-spray": {
    duo: {
      set_handle: "zahnpflege-professional-set",
      set_title: "SARI'S ZAHNPFLEGE PROFESSIONAL SET",
      set_price: 71.90,
      original_price: 84.85,
      saving_amount: 12.95,
      saving_percent: 15,
      cross_sell_handle: "dental-zaehne-mund-drops",
      sari_quote: "Für mich gehört beides zusammen – Spray für die Pflege, Drops für frischen Atem von innen.",
      benefits: [
        "Doppelte tägliche Maulpflege",
        "Für ein gepflegtes Maul und frischen Atem",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "komplette-maulgesundheit-set",
      set_title: "KOMPLETTE MAULGESUNDHEIT SET",
      set_price: 102.95,
      original_price: 122.80,
      saving_amount: 19.85,
      saving_percent: 16,
      contained_products: ["hunde-zahnstein-dental-spray", "dental-zaehne-mund-drops"],
      additional_handle: "immune-rote-beete-drops",
      sari_quote: "Mein Komplett-Bündel fürs Maul – ergänzt mit der Kraft der Roten Beete.",
      benefits: [
        "Maulpflege außen, innen und Vitalität dazu",
        "Drei Naturkraft-Begleiter im täglichen Ritual",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 2. GRAS-KOT AUSGLEICHER DROPS
  // ─────────────────────────────────────────────────────────
  "gras-kot-ausgleicher-drops": {
    duo: {
      set_handle: "magen-darm-harmonie-set",
      set_title: "SARI's MAGEN-DARM HARMONIE SET",
      set_price: 69.95,
      original_price: 83.85,
      saving_amount: 13.90,
      saving_percent: 17,
      cross_sell_handle: "gegen-hunde-durchfall",
      sari_quote: "Für mich gehören sie zusammen – damit der Bauch deines Lieblings rundum zur Ruhe kommt.",
      benefits: [
        "Begleitet sensible Verdauung",
        "Für das natürliche Gleichgewicht im Darm",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "entspannung-verdauung-premium-trio",
      set_title: "SARI's ENTSPANNUNG & VERDAUUNG PREMIUM TRIO",
      set_price: 102.95,
      original_price: 123.80,
      saving_amount: 20.85,
      saving_percent: 17,
      contained_products: ["gras-kot-ausgleicher-drops", "gegen-hunde-durchfall"],
      additional_handle: "ruhe-gelassenheit-drops",
      sari_quote: "Bauch und Gemüt hängen zusammen – mein Trio für entspannte, ausgeglichene Hunde.",
      benefits: [
        "Drei Begleiter für Bauch und innere Ruhe",
        "Für entspannte Momente im Alltag",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 3. GELENK-KNORPEL-SEHNEN DROPS · SAISONAL
  // ─────────────────────────────────────────────────────────
  "gelenk-knorpel-sehnen-drops": {
    seasonal: true,
    summer: {
      duo: {
        set_handle: "gelenk-ausdauer-set",
        set_title: "GELENK & AUSDAUER SET",
        set_price: 68.95,
        original_price: 80.85,
        saving_amount: 11.90,
        saving_percent: 15,
        cross_sell_handle: "konzentration-ausdauer",
        sari_quote: "Im Sommer für aktive Vierbeiner – Beweglichkeit trifft Ausdauer.",
        benefits: [
          "Begleitet die natürliche Beweglichkeit",
          "Für aktive Tage und lange Spaziergänge",
          "Rein pflanzlich, naturbelassen"
        ]
      },
      trio: {
        set_handle: "aktiv-gesund-komplett-set-1",
        set_title: "SARI's AKTIV & GESUND KOMPLETT-SET",
        set_price: 102.95,
        original_price: 120.80,
        saving_amount: 17.85,
        saving_percent: 15,
        contained_products: ["gelenk-knorpel-sehnen-drops", "konzentration-ausdauer"],
        additional_handle: "hunde-zahnstein-dental-spray",
        sari_quote: "Mein Rundum-Bündel für aktive Hunde – Bewegung, Ausdauer und Maulpflege im täglichen Ritual.",
        benefits: [
          "Drei Begleiter für Bewegung und Vitalität",
          "Für aktive Hunde in jeder Lebensphase",
          "Mit Sorgfalt in Deutschland hergestellt"
        ]
      }
    },
    winter: {
      duo: {
        set_handle: "gelenkfreude-warme-set",
        set_title: "SARI'S GELENKFREUDE & WÄRME SET",
        set_price: 69.95,
        original_price: 80.85,
        saving_amount: 10.90,
        saving_percent: 13,
        cross_sell_handle: "naesse-kalte-drops",
        sari_quote: "In der kalten Jahreszeit für meine vierbeinigen Freunde – Beweglichkeit auch bei Nässe und Wind.",
        benefits: [
          "Begleitet die natürliche Beweglichkeit",
          "Für entspannte Spaziergänge bei Nässe und Kälte",
          "Rein pflanzlich, naturbelassen"
        ]
      },
      trio: null // kein passendes Trio vorhanden
    }
  },

  // ─────────────────────────────────────────────────────────
  // 4. GASSI-SCHUTZ DROPS
  // ─────────────────────────────────────────────────────────
  "hunde-zeckenschutz-drops": {
    duo: {
      set_handle: "gassi-wellness-set",
      set_title: "SARI'S GASSI-WELLNESS SET",
      set_price: 69.95,
      original_price: 84.85,
      saving_amount: 14.90,
      saving_percent: 18,
      cross_sell_handle: "fell-haut-krallen-drops",
      sari_quote: "Outdoor-Begleiter aus meiner Werkstatt – für entspannte Touren von Pfote bis Fell.",
      benefits: [
        "Begleitet entspannte Spaziergänge in der Natur",
        "Für gepflegtes Fell und gepflegte Haut",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "schonheit-schutz-premium-set",
      set_title: "SCHÖNHEIT & SCHUTZ PREMIUM SET",
      set_price: 102.95,
      original_price: 124.80,
      saving_amount: 21.85,
      saving_percent: 18,
      contained_products: ["hunde-zeckenschutz-drops", "fell-haut-krallen-drops"],
      additional_handle: "hunde-zahnstein-dental-spray",
      sari_quote: "Außen, oben, im Maul – mein Dreiklang für rundum gepflegte Begleiter.",
      benefits: [
        "Pflege von Pfote bis Maul",
        "Drei Naturkraft-Begleiter im täglichen Ritual",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 5. RUHE & GELASSENHEIT DROPS
  // ─────────────────────────────────────────────────────────
  "ruhe-gelassenheit-drops": {
    duo: {
      set_handle: "harmonie-set-1",
      set_title: "SARI's HARMONIE SET",
      set_price: 70.95,
      original_price: 83.85,
      saving_amount: 12.90,
      saving_percent: 15,
      cross_sell_handle: "gegen-hunde-durchfall",
      sari_quote: "Bauch und Gemüt hängen zusammen – für mich gehört beides in fordernden Momenten dazu.",
      benefits: [
        "Begleitet innere Ruhe und sensible Verdauung",
        "Für entspannte Momente bei Reisen und Lärm",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "entspannung-verdauung-premium-trio",
      set_title: "SARI's ENTSPANNUNG & VERDAUUNG PREMIUM TRIO",
      set_price: 102.95,
      original_price: 123.80,
      saving_amount: 20.85,
      saving_percent: 17,
      contained_products: ["ruhe-gelassenheit-drops", "gegen-hunde-durchfall"],
      additional_handle: "gras-kot-ausgleicher-drops",
      sari_quote: "Mein Trio für Stress-empfindliche Hunde – innere Balance von Bauch bis Gemüt.",
      benefits: [
        "Drei Naturkraft-Begleiter für entspannte Tage",
        "Für mehr Wohlbefinden in fordernden Phasen",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 6. IMMUNE ROTE BEETE DROPS
  // ─────────────────────────────────────────────────────────
  "immune-rote-beete-drops": {
    duo: {
      set_handle: "bauch-immun-harmonie-set",
      set_title: "SARI's BAUCH & IMMUN HARMONIE SET",
      set_price: 69.95,
      original_price: 83.85,
      saving_amount: 13.90,
      saving_percent: 17,
      cross_sell_handle: "gras-kot-ausgleicher-drops",
      sari_quote: "Vitalität beginnt im Bauch – meine Empfehlung für Hunde mit Lebensfreude von innen heraus.",
      benefits: [
        "Begleitet Vitalität und natürliche Verdauung",
        "Für mehr Lebensfreude und Energie",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "3-fach-schutz-pflege-set",
      set_title: "SARI'S 3-FACH SCHUTZ & PFLEGE SET",
      set_price: 103.95,
      original_price: 123.80,
      saving_amount: 19.85,
      saving_percent: 16,
      contained_products: ["immune-rote-beete-drops", "gras-kot-ausgleicher-drops"],
      additional_handle: "hunde-zeckenschutz-drops",
      sari_quote: "Mein Dreiklang aus dem Inneren – Bauch, Vitalität und entspannte Spaziergänge.",
      benefits: [
        "Drei Begleiter für Vitalität in jeder Lebensphase",
        "Für entspannte Spaziergänge und mehr Lebensfreude",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 7. DENTAL DROPS
  // ─────────────────────────────────────────────────────────
  "dental-zaehne-mund-drops": {
    duo: {
      set_handle: "zahnpflege-professional-set",
      set_title: "SARI'S ZAHNPFLEGE PROFESSIONAL SET",
      set_price: 71.90,
      original_price: 84.85,
      saving_amount: 12.95,
      saving_percent: 15,
      cross_sell_handle: "hunde-zahnstein-dental-spray",
      sari_quote: "Für mich gehört beides zusammen – Drops für innen, Spray für die tägliche Maulpflege.",
      benefits: [
        "Doppelte tägliche Maulpflege",
        "Für ein gepflegtes Maul und frischen Atem",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "komplette-maulgesundheit-set",
      set_title: "KOMPLETTE MAULGESUNDHEIT SET",
      set_price: 102.95,
      original_price: 122.80,
      saving_amount: 19.85,
      saving_percent: 16,
      contained_products: ["dental-zaehne-mund-drops", "hunde-zahnstein-dental-spray"],
      additional_handle: "immune-rote-beete-drops",
      sari_quote: "Mein Komplett-Bündel fürs Maul – ergänzt mit der Kraft der Roten Beete.",
      benefits: [
        "Maulpflege außen, innen und Vitalität dazu",
        "Drei Naturkraft-Begleiter im täglichen Ritual",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 8. FELL-HAUT-KRALLEN DROPS
  // ─────────────────────────────────────────────────────────
  "fell-haut-krallen-drops": {
    duo: {
      set_handle: "fell-vital-premium-set",
      set_title: "FELL-VITAL PREMIUM SET",
      set_price: 68.95,
      original_price: 82.85,
      saving_amount: 13.90,
      saving_percent: 17,
      cross_sell_handle: "immune-rote-beete-drops",
      sari_quote: "Schönheit kommt von innen – mein Duo für gepflegtes Fell und vitale Hunde.",
      benefits: [
        "Pflege von außen, Vitalität von innen",
        "Für gepflegtes Fell, Haut und Krallen",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "immun-schonheit-premium-set",
      set_title: "SARI's IMMUN & SCHÖNHEIT PREMIUM SET",
      set_price: 102.95,
      original_price: 122.80,
      saving_amount: 19.85,
      saving_percent: 16,
      contained_products: ["fell-haut-krallen-drops", "immune-rote-beete-drops"],
      additional_handle: "hunde-zahnstein-dental-spray",
      sari_quote: "Außen, innen, im Maul – mein Trio für rundum gepflegte Lieblinge.",
      benefits: [
        "Drei Begleiter von Pfote bis Maul",
        "Für mehr Wohlbefinden im täglichen Ritual",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 9. DETOX & SOS DROPS
  // ─────────────────────────────────────────────────────────
  "gegen-hunde-durchfall": {
    duo: {
      set_handle: "magen-darm-harmonie-set",
      set_title: "SARI's MAGEN-DARM HARMONIE SET",
      set_price: 69.95,
      original_price: 83.85,
      saving_amount: 13.90,
      saving_percent: 17,
      cross_sell_handle: "gras-kot-ausgleicher-drops",
      sari_quote: "Für mich gehören sie zusammen – damit der Bauch deines Lieblings rundum zur Ruhe kommt.",
      benefits: [
        "Begleitet sensible Verdauung",
        "Für das natürliche Gleichgewicht im Darm",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "entspannung-verdauung-premium-trio",
      set_title: "SARI's ENTSPANNUNG & VERDAUUNG PREMIUM TRIO",
      set_price: 102.95,
      original_price: 123.80,
      saving_amount: 20.85,
      saving_percent: 17,
      contained_products: ["gegen-hunde-durchfall", "gras-kot-ausgleicher-drops"],
      additional_handle: "ruhe-gelassenheit-drops",
      sari_quote: "Bauch und Gemüt hängen zusammen – mein Trio für entspannte, ausgeglichene Hunde.",
      benefits: [
        "Drei Begleiter für Bauch und innere Ruhe",
        "Für entspannte Momente im Alltag",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 10. KONZENTRATION & AUSDAUER DROPS
  // ─────────────────────────────────────────────────────────
  "konzentration-ausdauer": {
    duo: {
      set_handle: "gelenk-ausdauer-set",
      set_title: "GELENK & AUSDAUER SET",
      set_price: 68.95,
      original_price: 80.85,
      saving_amount: 11.90,
      saving_percent: 15,
      cross_sell_handle: "gelenk-knorpel-sehnen-drops",
      sari_quote: "Körper und Kopf gehören zusammen – mein Duo für aktive, ausdauernde Hunde.",
      benefits: [
        "Begleitet Beweglichkeit und Ausdauer",
        "Für aktive Tage und lange Spaziergänge",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "aktiv-gesund-komplett-set-1",
      set_title: "SARI's AKTIV & GESUND KOMPLETT-SET",
      set_price: 102.95,
      original_price: 120.80,
      saving_amount: 17.85,
      saving_percent: 15,
      contained_products: ["konzentration-ausdauer", "gelenk-knorpel-sehnen-drops"],
      additional_handle: "hunde-zahnstein-dental-spray",
      sari_quote: "Mein Rundum-Bündel für aktive Hunde – Bewegung, Ausdauer und Maulpflege im täglichen Ritual.",
      benefits: [
        "Drei Begleiter für Bewegung und Vitalität",
        "Für aktive Hunde in jeder Lebensphase",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  },

  // ─────────────────────────────────────────────────────────
  // 11. NÄSSE-KÄLTE DROPS
  // ─────────────────────────────────────────────────────────
  "naesse-kalte-drops": {
    duo: {
      set_handle: "wetterschutz-professional-set",
      set_title: "SARI'S WETTERSCHUTZ PROFESSIONAL SET",
      set_price: 68.95,
      original_price: 78.85,
      saving_amount: 9.90,
      saving_percent: 13,
      cross_sell_handle: "immune-rote-beete-drops",
      sari_quote: "Für meine vierbeinigen Freunde durch Wind und Wetter – mit Vitalität von innen.",
      benefits: [
        "Begleitet entspannte Spaziergänge bei Nässe und Kälte",
        "Für mehr Vitalität in der kalten Jahreszeit",
        "Rein pflanzlich, naturbelassen"
      ]
    },
    trio: {
      set_handle: "immun-warme-zahnpflege-trio",
      set_title: "IMMUN-WÄRME-ZAHNPFLEGE TRIO",
      set_price: 102.95,
      original_price: 118.80,
      saving_amount: 15.85,
      saving_percent: 13,
      contained_products: ["naesse-kalte-drops", "immune-rote-beete-drops"],
      additional_handle: "hunde-zahnstein-dental-spray",
      sari_quote: "Mein Trio für die kalte Jahreszeit – Wetter, Vitalität und Maulpflege im Bündel.",
      benefits: [
        "Drei Begleiter für fordernde Wintermonate",
        "Für mehr Wohlbefinden in jeder Lebensphase",
        "Mit Sorgfalt in Deutschland hergestellt"
      ]
    }
  }

};


/**
 * SAISON-LOGIK
 * ─────────────────────────────────────────────────────────────
 * Liefert für saisonale Mappings (gelenk-knorpel-sehnen-drops) die
 * passende Variante. Bei nicht-saisonalen Mappings wird das Mapping
 * unverändert zurückgegeben.
 */
window.VBG_getMapping = function(handle, today) {
  const entry = window.VBG_UPSELL_MAP[handle];
  if (!entry) return null;
  if (!entry.seasonal) return entry;

  const d = today || new Date();
  const month = d.getMonth() + 1; // 1–12
  // Sommer: April (4) – September (9)
  // Winter: Oktober (10) – März (3)
  const isSummer = month >= 4 && month <= 9;
  return isSummer ? entry.summer : entry.winter;
};
